import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import { WebsiteTotalCountSummary } from '../dataObjects/WebsiteTotalCountSummary';
import { formatSecondsToMinutes } from '../../../utility/formatSecondsToMinutes';

interface totalCountSummaryProps {
    summary?: WebsiteTotalCountSummary;
}

const WebsiteTotalSummary = (props: totalCountSummaryProps) => {

    const formatNumberShort = (number: number) => {
        return Intl.NumberFormat('en', { notation: 'compact' }).format(number); 
    }

    return (
        <Stack direction="row" spacing={1} marginBottom={3} marginRight={2}>
            <Grid item xs={3}>
                <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
                    <CardContent>
                        <Typography color={'text.secondary'} variant="subtitle2" gutterBottom>
                            Active Users
                        </Typography>
                        <Typography variant="h5" component="p">
                            {props.summary?.activeUsers && formatNumberShort(props.summary?.activeUsers)}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={3}>
                <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
                    <CardContent>
                        <Typography color={'text.secondary'} variant="subtitle2" gutterBottom>
                            Event Count
                        </Typography>
                        <Typography variant="h5" component="p">
                            {props.summary?.eventCount && formatNumberShort(props.summary?.eventCount)}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={3}>
                <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
                    <CardContent>
                        <Typography color={'text.secondary'} variant="subtitle2" gutterBottom>
                            Page Views
                        </Typography>
                        <Typography variant="h5" component="p">
                            {props.summary?.pageViews && formatNumberShort(props.summary?.pageViews)}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={3}>
                <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
                    <CardContent>
                        <Typography color={'text.secondary'} variant="subtitle2" gutterBottom>
                            Average Session
                        </Typography>
                        <Typography variant="h5" component="p">
                            {props.summary?.averageSessionDuration && formatSecondsToMinutes(props.summary?.averageSessionDuration)}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
        </Stack>
    );
}

export default WebsiteTotalSummary 